import AlertMessage from './AlertMessageView';

export default AlertMessage;
